import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromProfile from 'app/reducers/profile';

@Injectable({ providedIn: 'root' })
export class AppRoutingPreloadStrategy implements PreloadingStrategy {
  private store = inject(Store);
  preload(route: Route, fn: () => Observable<unknown>): Observable<unknown> {
    switch (route?.path) {
      // cases here that loaded only for user with Digilog license
      case 'spare-parts':
      case 'incidents':
        return this.store.select(fromProfile.getDigilogLicenseState).pipe(
          switchMap((isDigilogLicenseActive: boolean) => isDigilogLicenseActive ? fn() : EMPTY),
        );
      default:
        return fn();
    }
  }
}
